import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { RegisterService } from 'src/app/core/services/register/register.service';
import { RoutesKeys } from 'src/app/utils/routes';

@Component({
  selector: 'app-expired-invite',
  templateUrl: './expired-invite.component.html',
  styleUrls: ['./expired-invite.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
/**
 * Expired Invite Component
 */
export class ExpiredInviteComponent {
  readonly homeRoute;

  /**
   * @constructor
   * @param {RegisterService} registerService
   * @param {Router} router
   */
  constructor(registerService: RegisterService, router: Router) {
    registerService.routingGuards.expiredInvite = false;
    this.homeRoute = router.parseUrl(RoutesKeys.HOME).toString();
  }
}
